import React from 'react';
import ReactDOM from 'react-dom/client';
import 'reflect-metadata';
import 'normalize.css';
import 'index.css';
// import 'react-image-crop/dist/ReactCrop.css';
import reportWebVitals from 'reportWebVitals';
import { ErrorBoundary } from 'ui/components/elements/ErrorBoundary/ErrorBoundary';
import { SentryErrorBoundary } from 'utils/sentry';
import { GlobalSnackbar } from 'ui/components/elements/SnackBar/GlobalSnackbar';
import { CookieConsent } from 'ui/components/elements/CookieConsent/CookieConsent';
import { useCookieConsent } from 'ui/components/elements/CookieConsent/useCookieConsent';
import RouterConfig from 'RouterConfig';
import { Variables } from 'Variables';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';

dayjs.locale('ja');
dayjs.extend(isSameOrAfter);

const AppWithCookieConsent: React.FC = () => {
    const { isVisible, acceptCookies, declineCookies } = useCookieConsent();

    return <>{isVisible && <CookieConsent onAccept={acceptCookies} onDecline={declineCookies} />}</>;
};

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    // <React.StrictMode>
    <ErrorBoundary>
        <SentryErrorBoundary>
            <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="ja"
                localeText={{
                    previousMonth: '前月', // < のツールチップ
                    nextMonth: '次月', // > のツールチップ
                }}
            >
                <Variables />
                <GlobalSnackbar />
                <RouterConfig />
                <AppWithCookieConsent />
            </LocalizationProvider>
        </SentryErrorBoundary>
    </ErrorBoundary>,
    // </React.StrictMode>,
);

reportWebVitals();
